import React, {useEffect} from 'react'
import {HashLink} from 'react-router-hash-link'

import {APP_ROUTES} from '../../../routes/routes'

const CareersSectionHeader = () => {

  const changeSubmenuStyleBasedOnScroll = ()=> {
    const header = document.querySelector('#header')
    const subMenu = document.querySelector('.nav-header')

    if (window.innerWidth > 990) {
      const currentScrollPos = window.scrollY

      if (currentScrollPos> 90) {
        header.classList.add('hidden')
        subMenu.classList.add('fixed')
      } else {
        header.classList.remove('hidden')
        subMenu.classList.remove('fixed')
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', changeSubmenuStyleBasedOnScroll)

    return () => window.removeEventListener('scroll', changeSubmenuStyleBasedOnScroll)
  }, [])

  const links = [
    {id: 'welcome', label: 'Welcome to Creditstar'},
    {id: 'careers-open-positions', label: 'Open positions'},
    {id: 'reasons', label: 'Reasons to work at Creditstar'},
    {id: 'testimonials-about', label: 'Testimonials'},
    {id: 'perks', label: 'Perks & benefits'},
    {id: 'departments', label: 'Our departments'},
    {id: 'social-media', label: 'Social'}
  ]

  return (
    <div className="nav-header">
      <div className="nav-header-container">
        <ul>
          {links.map(({id, label}) => {
            return (
              <li key={`careers-sub-menu-${id}`}>
                <HashLink to={`${APP_ROUTES.CAREERS}#${id}`}>{label}</HashLink>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default CareersSectionHeader
